import React, { Component } from 'react';
import { func } from 'prop-types';
import TextInput from 'sub_components/Common/BloxTextInput';
import { INPUT_TYPES, PHONEMASKDOTS } from 'utils/CommonConstants';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
const emailValidations = [
	{ message: 'Required field', pattern: /.+/ },
	{ message: 'Please enter a valid email address.', pattern: /^[^@\s]+@[^@\s]+\.[^@\s]+$/ },
];
const phoneValidations = [
	{ message: 'Required field', pattern: /.+/ },
	{ message: 'Phone Number must be 10 digits', pattern: /^[0-9]{10}$/ },
];

const CDN_URL = process.env.REACT_APP_CDN_URL;

const checkmark = `${CDN_URL}common/icons-forms-check.svg`;
class AddPreference extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			phone: '',
		};
	}

	formatNumber = number => {
		return number.replace('(', '').replace(')', '.').replace(' ', '').replace('-', '.');
	};

	render() {
		const {
			preference,
			data,
			iconActive,
			iconDefault,
			setSelected,
			selected,
			onFieldComplete,
			onChange,
			email,
			phone,
		} = this.props;

		return (
			<div className='add-preference-wrapper'>
				<ScrollView>
					<div className='preference-selection-wrapper'>
						{data &&
							data.length !== 0 &&
							data[0] !== '' &&
							data.map((item, index) => (
								<div
									className={
										selected === item
											? 'preference-wrapper body10 selected'
											: 'preference-wrapper body10'
									}
									onClick={() => {
										setSelected(item);
									}}
									data-cy={`preference-${index}`}
									id={`preference-${index}`}
								>
									<div className='checkmark'>
										<img src={checkmark} />
									</div>
									<div className='icon'>
										<img src={selected === item ? iconActive : iconDefault} />
									</div>
									<div className='details'>
										<div className='title heading90'>{preference}</div>
										<div className='text body10'>
											{preference === 'email' ? item : this.formatNumber(item)}
										</div>
									</div>
								</div>
							))}
						<div
							className={selected === 'custom' ? 'add selected' : 'add'}
							onClick={() => {
								setSelected('custom');
							}}
						>
							<div className='add-icon'>+</div>
							<div className='icon'>
								<img src={selected === 'custom' ? iconActive : iconDefault} />
							</div>
							{preference === 'email' && (
								<TextInput
									placeholder={'Add an email'}
									active={true}
									type={INPUT_TYPES.INPUT}
									label='EMAIL'
									name='email'
									value={email}
									validations={emailValidations}
									onChange={onChange}
									markComplete={onFieldComplete}
									cypressId='email-input'
								/>
							)}

							{preference === 'phone' && (
								<TextInput
									placeholder={'Add a number'}
									active={true}
									type={INPUT_TYPES.INPUT}
									label='PHONE'
									name='phone'
									value={phone}
									mask={PHONEMASKDOTS}
									validations={phoneValidations}
									onChange={onChange}
									markComplete={onFieldComplete}
									cypressId='phone-input'
								/>
							)}
						</div>
					</div>
				</ScrollView>
			</div>
		);
	}
}

AddPreference.propTypes = {
	updateEditParams: func,
};

AddPreference.defaultProps = {
	updateEditParams: () => {},
};

export default AddPreference;
